import { API_URL } from "env";

async function createAdvancedFeature({ name, description, key, number }: { name: string; description: string; key?: string; number?: number }): Promise<number | null> {
    const token = localStorage.getItem("token");
    try {
        if (!token) throw new Error("No token found");
        const response = await fetch(`${API_URL}api/v1/be/features`, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${token}`,
            },
            body: JSON.stringify({
                name,
                description,
                key,
                number
            }),
        });
        const data = await response.json();
        if (!data) {
            throw new Error(data.message || "Failed to create advanced feature");
        }
        return data.id || null;
    }
    catch (error) {
        console.error("Error creating advanced feature:", error);
        return null;
    }
}

async function createAndAddAdvancedFeature(
    subcriptionId: number[],
    feature: { name: string; description: string; key?: string; number?: number }
) {
    const token = localStorage.getItem("token");
    try {
        if (!token) throw new Error("No token found");
        const response = await fetch(`${API_URL}api/v1/be/features`, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${token}`,
            },
            body: JSON.stringify({
                name: feature.name,
                description: feature.description,
                key: feature.key,
                number: feature.number,
                subscription_ids: subcriptionId
            }),
        });
        const data = await response.json();
        if (!data) {
            throw new Error(data.message || "Failed to create advanced feature");
        }
        return data.id || null;
    }
    catch (error) {
        console.error("Error creating advanced feature:", error);
        return null;
    }
}

export { createAdvancedFeature, createAndAddAdvancedFeature };